// -------------------------
// SELECTORS

import { ApplicationState } from '@app/store'
import { createSelector } from 'reselect/lib'

// -------------------------
const selectModuleState = () => (state: ApplicationState) =>
  state.brokeragePipelineEdit

export const selectEditCriticalDateIndex = () =>
  createSelector(selectModuleState(), (mState) => mState.editCriticalDateIndex)

export const selectError = () =>
  createSelector(selectModuleState(), (mState) => mState.error)

export const selectIsLoading = () =>
  createSelector(selectModuleState(), (mState) => mState.isLoading)

export const selectCheckPipelineExists = () =>
  createSelector(selectModuleState(), (mState) => mState.hasExistingPipeline)

export const selectIsReady = () =>
  createSelector(selectModuleState(), (mState) => mState.isReady)

export const selectIsSaving = () =>
  createSelector(selectModuleState(), (mState) => mState.isSaving)

export const selectPipeline = () =>
  createSelector(selectModuleState(), (mState) => mState.pipeline)

export const selectShowCriticalDateModal = () =>
  createSelector(selectModuleState(), (mState) => mState.showCriticalDateModal)
